export default {
  data: function() {
    return {
      // Default data
      loanTypeData: [
        { name: 'New', value: 'new', default: true },
        { name: 'Used', value: 'used', default: false }
      ],

      // Terms drop-down
      loanTypeItems: [],
      loanTypeSelected: '',

      // Info
      productTypeInfo: [
        {
          copyTitle: 'Purchase',
          copy: 'If you are looking to buy a new or used vehicle.'
        },
        {
          copyTitle: 'Refinance',
          copy:
            'If you are looking for a lower interest rate or monthly payment on an existing auto loan.'
        }
      ],

      productDescription: [
        {
          copy:
            'Select whether you are interested in buying a new or a used car. If you are not sure, select both options to see auto loan offers for new and used vehicles.'
        }
      ]
    }
  }
}
